export function MapPlaceholder() {
  return (
    <div tw="flex h-full w-full items-center justify-center bg-grey-20-light">
      <span tw="font-aeonik text-mobile-caption-20-normal text-grey-70-light">Map preview unavailable</span>
    </div>
  );
}
